<!--
  VCart

  還原自 index.pretty.js L2335。render function 已轉回 template。

  購物車側欄：列出已加入的品項（數量、飲品名、冰塊／甜度／加料、小計），
  底部顯示外送折扣與結帳按鈕。

  外送折扣規則：每滿 11 杯折 50 元（Math.floor(杯數 / 11) * 50），
  對應 i18n 的 delivery_discount_notes「外送享 11 杯現折 50 元」。

  結帳按鈕的三種狀態：
    店休          -> 灰色停用，顯示 close
    未達成立條件  -> 灰色停用，顯示 order_fail
    可結帳        -> 主色，顯示總金額
-->

<template>
  <div
    class="cart-container card align-center d-flex jc-center fd-row p-flex t-0 b-0"
    @scroll="scrollEvent"
  >
    <div class="wrapper_flex">
      <div class="header-sticky-container" :class="{ show: header_show }">
        <div class="d-flex jc-space">
          <div class="title font-24">
            <p>{{ $t('your_order') }}</p>
          </div>
          <div>
            <i class="font-28 material-icons hover t-gray-7 c-pointer" @click="close">close</i>
          </div>
        </div>
      </div>

      <div class="list-container p-t-8">
        <div v-for="(item, index) in cart_list" :key="index" @click="select_item(item)">
          <div class="card-list card-hover">
            <div class="d-flex a-center jc-space p-l-40 p-r-40">
              <div class="d-flex a-center">
                <div class="cart-label">
                  <p class="font-18 t-align-center">{{ item.count }}</p>
                </div>

                <div>
                  <div class="d-flex p-b-8 a-center">
                    <p class="font-18">{{ item.drink }}</p>
                  </div>

                  <div class="d-flex t-gray-7">
                    <p v-if="item.ice_selected !== null" class="font-16">{{ item.ice_selected }} </p>
                    <p v-if="item.suger_selected !== null" class="font-16">{{ item.suger_selected }} </p>
                    <p v-if="item.feed_selected !== null" class="font-16">
                      {{ item.feed_selected.item }} (+NT${{ item.feed_selected.feed_price }})
                    </p>
                    <p v-if="item.feed_sold_out !== null" class="font-16 td-line-through">
                      {{ item.feed_sold_out }}
                    </p>
                  </div>
                </div>
              </div>

              <div class="title font-18">
                <p>NT${{ item.total_price }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="footer-sticky-container">
        <div
          v-if="order_type === 'ORDER_TYPE_DELIVERY'"
          class="d-flex jc-space a-center m-b-18"
        >
          <div class="d-flex fd-column jc-space">
            <p class="t-gray-7 font-18">{{ $t('discount_title') }}</p>
            <p class="t-gray-7 font-16 p-t-4">{{ $t('delivery_discount_notes') }}</p>
          </div>
          <p class="t-gray-7 font-18">-NT${{ discount }}</p>
        </div>

        <button v-if="is_close === true" class="btn btn-grey btn-fill" disabled>
          <p class="t-gray-10 font-18">{{ $t('close') }}</p>
        </button>

        <button
          v-else-if="access_checkout"
          class="btn btn-primary btn-fill d-flex jc-space a-center"
          @click="checkout"
        >
          <p class="flex-1 s-screen"></p>
          <p class="flex-2 t-align-center font-18">{{ $t('go_to_checkout') }}</p>
          <p class="flex-1 t-align-right font-18">NT${{ total_price - discount }}</p>
        </button>

        <button v-else class="btn btn-grey btn-fill" disabled>
          <p class="t-gray-10 font-18">{{ $t('order_fail') }}</p>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import * as types from '@/store/mutation-types'

/** 外送折扣：每滿 11 杯折 50 元 */
const CUPS_PER_DISCOUNT = 11
const DISCOUNT_PER_UNIT = 50

/** 外送最遠距離（公里），超過就不接單 */
const MAX_DELIVERY_KM = 10

export default {
  props: ['is_close', 'cart_list', 'delivery', 'order_type'],

  data() {
    return { total_price: 0, header_show: false, discount: 0 }
  },

  computed: {
    access_checkout() {
      if (this.order_type === types.ORDER_TYPE_DELIVERY) {
        // 外送：折扣後金額要達到運費門檻，且距離不超過上限
        return (
          this.total_price - this.discount >= this.delivery.fee &&
          this.delivery.distance <= MAX_DELIVERY_KM
        )
      }

      return this.total_price > 0
    }
  },

  watch: {
    cart_list: {
      deep: true,
      handler() {
        this.cal_total_price()
      }
    },

    order_type() {
      this.cal_total_price()
    }
  },

  methods: {
    ...mapActions(['setOpenCart']),

    scrollEvent(event) {
      this.header_show = event.srcElement.scrollTop > 50
    },

    close() {
      this.$emit('event', 'cart_close')
    },

    checkout() {
      this.setOpenCart(false)
      this.$emit('event', 'checkout')
    },

    select_item(item) {
      this.$emit('select', item)
    },

    cal_total_price() {
      let total = 0
      let cups = 0

      for (const key in this.cart_list) {
        total += this.cart_list[key].total_price

        if (this.order_type === types.ORDER_TYPE_DELIVERY) {
          cups += this.cart_list[key].count
        }
      }

      if (this.order_type === types.ORDER_TYPE_DELIVERY) {
        this.discount = Math.floor(cups / CUPS_PER_DISCOUNT) * DISCOUNT_PER_UNIT
      } else {
        this.discount = 0
      }

      this.total_price = total
    },

    trigger_event(event) {
      switch (event) {
        case 'close':
          this.order_show = false
          break
      }
    }
  },

  created() {},

  destroyed() {},

  mounted() {}
}
</script>
